import request from '../request';

export function getRegions(params) {
  return request({
    url:'management/regions',
    method:'get',
    params,
  })
}

export function showRegions(id) {
  return request({
    url: `management/regions/${id}`,
    method: "get"
  })
}

export function updateRegions(data) {
  return request({
    url: "management/regions",
    method: "post",
    data
  })
}

export function addRegions(data) {
  return request({
    url: `management/regions/${data.id}`,
    method: "put",
    data
  })
}

export function deleteRegions(id) {
  return request({
    url: `management/regions/${id}`,
    method: "delete",
  })
}